// extracted by mini-css-extract-plugin
export default {"valiated_message":"style_valiated_message__BQsvG","validated_failed":"style_validated_failed__ktAys","validated_success":"style_validated_success__cj8Y-"};